import React from "react";
import useNfuTiposMes from "../../../hooks/administrador/general/useNfuTiposMes";
import EchartsWrapper from "../../../pages/EchartsWrapper";
import '../../../styles/administrador.css';

const NfuTiposMes = ({ year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada }) => {
  const { data, loading, error } = useNfuTiposMes(
    year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada
  );
  
  if (loading) {
    return (
      <div className="grafica loading-container">
        <p>Cargando datos de NFU por tipo...</p>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="grafica error-container">
        <p>Error: {error}</p>
      </div>
    );
  }
  
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="grafica empty-container">
        <p>No hay datos disponibles para los filtros seleccionados.</p>
      </div>
    );
  }

   
  const ordenTipos = ['PLT', 'CVT', 'OTR', 'MOT', 'BICI'];
  const colorPalette = ['#d1dc5a', '#6ac5cb', '#45444e', '#a3b85b', '#3a6b74'];

  const nombresMeses = {
    1: 'Enero', 2: 'Febrero', 3: 'Marzo', 4: 'Abril', 
    5: 'Mayo', 6: 'Junio', 7: 'Julio', 8: 'Agosto', 
    9: 'Septiembre', 10: 'Octubre', 11: 'Noviembre', 12: 'Diciembre'
  };

  const allMonths = new Set(data.map(item => Number(item.id_mes)));
  const mesesOrdenados = Array.from(allMonths).sort((a, b) => a - b);
  const mesesFormateados = mesesOrdenados.map(mes => 
    nombresMeses[mes]?.substring(0, 3).toUpperCase() || `M${mes}`);

   
  const dataFusionada = data.map(item => 
    item.categoria === 'PLT 2' ? { ...item, categoria: 'PLT' } : item);

   
  const seriesData = {};
  mesesOrdenados.forEach(mes => {
    seriesData[mes] = {};
    ordenTipos.forEach(tipo => {
      seriesData[mes][tipo] = 0;
    });
  });

  dataFusionada.forEach(item => {
    const mes = Number(item.id_mes);
    const tipo = item.categoria;
    const valor = Number(item.cantidad_entregada) || 0;

    if (ordenTipos.includes(tipo)) {
      seriesData[mes][tipo] += valor;
    }
  });

   
  const series = ordenTipos.map((tipo, index) => ({
    name: tipo,
    type: 'bar',
    stack: 'total',
    data: mesesOrdenados.map(mes => seriesData[mes][tipo] || 0),
    emphasis: { focus: 'series' },
    itemStyle: { color: colorPalette[index % colorPalette.length] }
  }));

   
  let totalEntregados = 0;
  ordenTipos.forEach(tipo => {
    mesesOrdenados.forEach(mes => {
      totalEntregados += seriesData[mes][tipo] || 0;
    });
  });

   
  const chartOptions = {
    title: {
      text: "NFU entregados por tipo y por mes",
      left: 'center',
      subtext: `TOTAL NFU ENTREGADOS: ${totalEntregados.toLocaleString()}`,
      subtextStyle: { fontWeight: 'bold', fontSize: '12px' }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: function(params) {
        let result = `<b>${params[0].axisValueLabel}</b><br/>`;
        let total = 0;

        const paramsPorNombre = {};
        params.forEach(param => {
          paramsPorNombre[param.seriesName] = param;
        });

        ordenTipos.forEach(tipo => {
          if (paramsPorNombre[tipo]) {
            const param = paramsPorNombre[tipo];
            result += `${param.marker} ${param.seriesName}: <b>${param.value.toLocaleString()} [U]</b><br/>`;
            total += param.value;
            delete paramsPorNombre[tipo];
          }
        });

        for (const seriesName in paramsPorNombre) {
          const param = paramsPorNombre[seriesName];
          result += `${param.marker} ${param.seriesName}: <b>${param.value.toLocaleString()} [U]</b><br/>`;
          total += param.value;
        }

        result += `<br/><b>Total: ${total.toLocaleString()} [U]</b>`;
        return result;
      }
    },
    legend: {
      data: ordenTipos,
      bottom: 0
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '60px',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: mesesFormateados,
      axisLabel: { fontSize: 10, fontWeight: 'bold' }
    },
    yAxis: {
      type: 'value',
      name: '',
      axisLabel: { formatter: value => value.toLocaleString() }
    },
    series: series
  };

  return <EchartsWrapper options={chartOptions} style={{ width: "100%", height: "400px" }} />;
};

export default NfuTiposMes;